export default __webpack_public_path__ + "static/media/revicon1.26f71426.svg";